import React, { useEffect } from 'react';
import { Button, HStack, VStack, Img, VisuallyHidden } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans } from '@lingui/macro';

import UnassignedModal from './unassigned-modal';
import { constructModal } from '../modal/modal-actions';
import { useValidate } from './hooks/use-validate';
import InfoFeedback from '../info-feedback/info-feedback';
import { validateAnswer } from '../conquest/conquest.actions';
import { disableSpinner, enableSpinner, recordTime, TIMESTAMP_CHECK } from '../mle/mle-actions';
import { ANSWER_VALIDATION_SPINNER } from './footer-qtc.actions';
import { useValidationCapsule } from './hooks/use-validation-capsule';
import { useFinish } from './hooks/use-finish';
import { useTeacherNotes } from './hooks/use-teacher-notes';
import iconTeacherNotes from '../../assets/images/icon_teacher_notes.svg';
import css from './footer-qtc.scss';

export const FooterQtc = () => {
  const dispatch = useDispatch();
  const { isReady, answer, validation } = useSelector(state => state.conquestReducer);
  const { mutate: validate, data: saveResult, isSuccess, isPending } = useValidate();
  const { supportingText, score, borderColor, announcement } = useValidationCapsule(validation);
  const { handleFinish, hasFinished } = useFinish();
  const { isTeacher, checkIsTeacher, handleTeacherNotes } = useTeacherNotes();

  useEffect(() => {
    if (isSuccess && saveResult && saveResult.data && saveResult.data.validation) {
      if (!isTeacher) {
        dispatch(recordTime(TIMESTAMP_CHECK));
      }
      dispatch(validateAnswer(saveResult.data));
    } else if (isSuccess && saveResult.data && saveResult.data.statusMessage) {
      dispatch(constructModal({
        activate: true,
        content: <UnassignedModal />,
        canvasOnClick: false
      }));
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isPending) {
      dispatch(enableSpinner(ANSWER_VALIDATION_SPINNER));
    } else {
      dispatch(disableSpinner(ANSWER_VALIDATION_SPINNER));
    }
  }, [isPending]);

  const actionButton = validation ? (
    <Button
      variant={'mle'}
      isDisabled={!validation || isTeacher || hasFinished}
      onClick={handleFinish}
    >
      <Trans>Finish</Trans>
    </Button>
  ) : (
    <Button
      isDisabled={!isReady || isPending}
      onClick={() => validate(answer)}
      variant={'mle'}
    >
      <Trans>Check</Trans>
    </Button>
  );

  return (
    <VStack
      className={css['footer-qtc']}
      alignItems="flex-start"
      justifyContent="space-between"
      borderTopWidth="4px"
      borderTopStyle={validation ? 'solid' : 'none'}
      borderTopColor={borderColor}
      fontFamily="Sofia Pro"
      spacing="0"
    >
      <VisuallyHidden role="status" aria-atomic="true">{announcement}</VisuallyHidden>
      {supportingText}
      <HStack spacing="20px" justifyContent={validation ? 'space-between' : 'flex-end'} w="100%">
        {score}
        <HStack spacing="20px" className={css.dialogue}>
          {
            checkIsTeacher &&
            <Button
              onClick={handleTeacherNotes}
              className={css['teacher-note-btn']}
            >
              <Img src={iconTeacherNotes} />
            </Button>
          }
          <InfoFeedback />
          {actionButton}
        </HStack>
      </HStack>
    </VStack>
  );
};
